import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "about",
  class: "bg-hex-323232 z-5 relative pt-41px pb-115px"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_about_section_text = _resolveComponent("the-about-section-text")!
  const _component_the_about_section_numbers = _resolveComponent("the-about-section-numbers")!
  const _component_central_block = _resolveComponent("central-block")!
  const _component_the_about_section_companies = _resolveComponent("the-about-section-companies")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_central_block, {
        white: "",
        overlap: "",
        title: "О нас",
        image: require('@/assets/img/img_2_step_bg_2.jpg'),
        subtitle: "Расчетный счет и не только"
      }, {
        centr_content: _withCtx(() => [
          _createVNode(_component_the_about_section_text)
        ]),
        abs_content: _withCtx(() => [
          _createVNode(_component_the_about_section_numbers)
        ]),
        _: 1
      }, 8, ["image"]),
      _createVNode(_component_the_about_section_companies, { class: "mt-120px <sm:mt-35px" })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "h-150px <lg:h-100px <sm:h-50px w-full bg-hex-323232",
      style: {"clip-path":"polygon(0% 100%, 100% 0%, 100% 0%, 0% 0%)"}
    }, null, -1))
  ], 64))
}